export default __webpack_public_path__ + "static/media/industry2.db0d347d.png";